import { SectionTitle } from "@bleu.builders/ui";
import React from "react";

import { useUser } from "#/contexts/UserContext";
import { Dashboard, UserPagePath } from "#/lib/pagesHelper";

export default function Transactions() {
  const { user } = useUser();

  const credits = user.organization.available_credits_amount;
  const creditsLabel = credits === 1 ? "crédito" : "créditos";
  return (
    <div>
      <div className="mb-10">
        <div className="flex items-center justify-between space-y-2 mb-4">
          <div>
            <SectionTitle>
              <span className="font-title">Histórico de Créditos</span>
            </SectionTitle>
            <p className="text-muted-foreground">
              Atualmente você possui {credits} {creditsLabel}.
            </p>
          </div>
        </div>
        <Dashboard
          fetchPath={UserPagePath.SETTINGS_USER_CREDITS}
          action={undefined}
          searchKey="reason"
        />
      </div>
    </div>
  );
}
